// src/App.js
import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Sidebar from "../components/Dashboard/Sidebar";
import DashboardIndex from "../pages/DashboardIndex";
import Navbar from "../components/Dashboard/Navbar";
import { useAuthStore } from "../context/useAuthStore";
import CabeceraComponent from "../components/Dashboard/CabeceraComponent";
import AdminUsers from "../pages/AdminUsers";
import TokensNoValidados from "../pages/OtpsNoValidados";
import SociosRegistrados from "../pages/SociosRegistrados";
import DevicesSociosNotifications from "../pages/DevicesSociosNotifications";
import GestionarPublicidad from "../pages/GestionarPublicidad";
import SolicitudesNuevosSocios from "../pages/SolicitudesNuevosSocios";
import EnviarNotificaciones from "../pages/EnviarNotificaciones";
import HeaderComponent from "../components/Dashboard/HeaderComponent";
import { Container } from "@mui/material";
function Dashboard() {
  const { Worker, logout }: any = useAuthStore();

  const email = Worker?.email;
  const nombre = Worker?.displayName;

  const handleLogout = () => {
    // Lógica para cerrar sesión
    logout();
  };

  return (
    <Router>
      <div className="d-flex flex-column">
        <HeaderComponent />
        <div className="flex-grow-1 d-flex">
          {/* Sidebar */}
          {/* Main content */}
          <div className="flex-grow-1 main-content">
            <Navbar username={nombre} onLogout={handleLogout} />
            <div className="container mt-4 ">
              <Routes>
                <Route path="/" element={<DashboardIndex />} />
                <Route path="/dashboard" element={<DashboardIndex />} />
                <Route
                  path="/otps-validacion"
                  element={<TokensNoValidados />}
                />
                <Route path="/adminUsers" element={<AdminUsers />} />
                <Route
                  path="/socios-registrados"
                  element={<SociosRegistrados />}
                />
                <Route
                  path="/devices-socios-notifications"
                  element={<DevicesSociosNotifications />}
                />
                <Route
                  path="/enviar-notificaciones"
                  element={<EnviarNotificaciones />}
                />
                <Route
                  path="/publicidad-carousel"
                  element={<GestionarPublicidad />}
                />
                <Route
                  path="/solicitudes-nuevos-socios"
                  element={<SolicitudesNuevosSocios />}
                />
              </Routes>
            </div>
          </div>
        </div>
      </div>
    </Router>
  );
}

export default Dashboard;
